import { render, staticRenderFns } from "./aigcCompany.vue?vue&type=template&id=3a6f16cd&scoped=true&"
import script from "./aigcCompany.vue?vue&type=script&lang=js&"
export * from "./aigcCompany.vue?vue&type=script&lang=js&"
import style0 from "./aigcCompany.vue?vue&type=style&index=0&id=3a6f16cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6f16cd",
  null
  
)

export default component.exports